import { gql } from '@apollo/client';

export const GENERATE_TEXT_MUTATION = gql`
  mutation generateText(
    $organizationId: String!
    $config: ContentGenerationInput!
  ) {
    generateText(organizationId: $organizationId, config: $config) {
      ... on TextGenerated {
        suggestions {
          content
        }
      }
      ... on CommonError {
        code
        success
        message
        error
      }
    }
  }
`;
